import * as ssnValidatorErrors from './errors';
import * as frenchSSN from './fr';
import * as italianSSN from './it';
import * as usSSN from './us';
var ssnStrategies = {
    FR: frenchSSN,
    IT: italianSSN,
    US: usSSN,
};
var ssnValidator = function (country) { return ssnStrategies[country]; };
export { ssnValidator };
export { ssnValidatorErrors };
